import { render, staticRenderFns } from "./ReviewReplacementSummary.vue?vue&type=template&id=2f67cab2&"
import script from "./ReviewReplacementSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewReplacementSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReplacementSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f67cab2')) {
      api.createRecord('2f67cab2', component.options)
    } else {
      api.reload('2f67cab2', component.options)
    }
    module.hot.accept("./ReviewReplacementSummary.vue?vue&type=template&id=2f67cab2&", function () {
      api.rerender('2f67cab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/ReviewReplacementSummary.vue"
export default component.exports